import { module } from 'modujs';
import Swiper from 'swiper';
import { Autoplay } from 'swiper/modules';

export default class extends module {
    constructor(m) {
        super(m);
        this.type = this.el.querySelector('.m-gallery_list').classList.contains('-landscape') ? 'landscape' : 'portrait';
    }

    init() {
        this.swiper = new Swiper(this.el.querySelector('.swiper'), {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: true,
            centeredSlides: true,
            autoplay: {
                delay: 2500,
                disableOnInteraction: false,
            },
            breakpoints: {
                480: {
                    slidesPerView: this.type === 'landscape' ? 3 : 4,
                    spaceBetween: 20
                },
            },
            modules: [Autoplay],
        });
    }
}
